import { Switch, Route, Redirect } from 'react-router-dom';

import useProtectedByAuth from '@giro-pdv/hooks/useProtectedByAuth.hook';

import AppLayout from '@giro-pdv/layouts/App.layout';

import ROUTES from '@giro-pdv/constants/routes.constant';

import SlipsScreen from './screens/Slips.screen';
import DialogSendSlipComponent from './components/DialogSendSlip.component';

const ReceiptModule = () => {
  useProtectedByAuth();

  return (
    <AppLayout>
      <Switch>
        <Route exact path={ROUTES.SLIPS.ROOT} component={SlipsScreen} />

        <Redirect to={ROUTES.PDV.ROOT} />
      </Switch>
      <DialogSendSlipComponent />
    </AppLayout>
  );
};

export default ReceiptModule;
